// Events
import { CART_CHANGED, CART_STAGE_UPDATE, CART_UPDATING, THEME_CART_UPDATED } from 'events';
import debounce from 'lodash/debounce';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import { dispatch } from 'utils/theme';

export default component((node, ctx) => {
  const { cartQuantity } = choozy(node);
  const byobDiscountCode = new URLSearchParams(decodeURI(window.location.search)).get('discount');
  // Store multiple changes in one go
  let updates = {};

  if (byobDiscountCode) fetch(`${window.location.origin}/discount/${byobDiscountCode}`);

  // eslint-disable-next-line
  const submitCartChange = debounce(async (e) => {
    e.stopPropagation();

    ctx.emit(CART_UPDATING);

    const response = await fetch(`${theme.endpoints.cartUpdate}.js`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates,
      }),
    });

    // eslint-disable-next-line
    if (response.status !== 200) return console.error(response);

    const json = await response.json();

    updates = {};

    ctx.emit(THEME_CART_UPDATED, { cart: json });
  }, 700);

  node.addEventListener('cart:change', (e) => {
    const { cart } = ctx.getState();
    const { detail } = e;
    const { id: itemKey, quantity: newQuantity, oldQuantity } = detail;
    const cartItem = cart.items.find((item) => item.key === itemKey);

    ctx.emit(CART_CHANGED, null, detail);
    updates[itemKey] = detail.quantity;

    if (newQuantity > oldQuantity) {
      dispatch('add-to-cart', {
        items: [cartItem],
        quantity: Math.abs(newQuantity - oldQuantity),
        placement: 'cart_item',
      });
    } else {
      dispatch('remove-from-cart', {
        item: cartItem,
        quantity: Math.abs(newQuantity - oldQuantity),
      });
    }

    // Check if cart is empty with new updates
    Object.keys(updates).forEach((id) => {
      const quantity = updates[id];

      cart.items.forEach((item) => {
        if (item.key !== id) return;

        item.quantity = quantity;
      });

      cart.items = cart.items.filter((item) => item.quantity > 0);

      let itemCount = 0;
      let originalTotalPrice = 0;
      let totalPrice = 0;

      cart.items.forEach((item) => {
        itemCount += item.quantity;
        originalTotalPrice += item.price * item.quantity;
        totalPrice += item.price * item.quantity;
      });

      cart.item_count = itemCount;
      cart.original_total_price = originalTotalPrice;
      cart.total_price = totalPrice;
    });

    if (cart.item_count === 0) {
      ctx.emit(THEME_CART_UPDATED, { cart });
    }

    ctx.emit(CART_STAGE_UPDATE, null, cart);

    submitCartChange(e);
  });

  ctx.on(THEME_CART_UPDATED, ({ cart }) => {
    node.classList[cart.items.length > 0 ? 'remove' : 'add']('is-empty');

    if (cartQuantity) {
      cartQuantity.textContent = cart.item_count;
    }
  });

  ctx.on(CART_STAGE_UPDATE, (state, updatedCart) => {
    if (cartQuantity) {
      cartQuantity.textContent = updatedCart.item_count;
    }
  });
});
